export const mockStats = {
  kmLast24Hours: '233,518',
  totalActiveLoadsValue: '$10,484,634',
  totalJobsSinceInception: '637,707',
  kmLast12Months: '60,437,659',
  loadsPerYear: '46,560'
};

export const mockFeatures = [
  {
    icon: 'shield',
    title: 'Secure Payment',
    description: 'Payment guaranteed, funds are held by Truckn Send It and released immediately via OSKO to your account once Proof of Delivery is received and confirmed',
    link: '/how-it-works/shippers'
  },
  {
    icon: 'truck',
    title: 'Insured Carriers',
    description: 'Get peace of mind by selecting fully vetted and insured carriers to move your high value projects',
    link: '/how-it-works/shippers'
  },
  {
    icon: 'message-circle',
    title: 'Communication',
    description: 'Stay updated. Chat or call your carrier or our team from anywhere, on any device, at any time',
    link: '/how-it-works/shippers'
  }
];

export const mockTestimonials = [
  {
    text: 'We\'ve never had to run empty, the staff at Truckn Send It have an extensive network of transport personnel Australia wide and have always found us a load home or something to fill our quiet days, it\'s great to be able to pick up the phone any time and know they will answer and help wherever possible.',
    author: 'JSE Freight Services',
    role: 'SA'
  }
];

export const mockCargoCategories = [
  'Boat Transport',
  'Bulk Tipper Transport',
  'Car Transport',
  'Caravan Transport',
  'Container Transport',
  'Furniture Removal',
  'General Freight',
  'Grain Transport',
  'Hay Transport',
  'Heavy Haulage',
  'Hot Shot',
  'Liquid Tanker Transport',
  'Livestock Transport',
  'Machinery Transport',
  'Oversize Load',
  'Palletised Freight',
  'Pilot Job',
  'Portable Buildings',
  'Trailer Transport',
  'Truck Transport',
  'Tractor Transport',
  'Generator Transport',
  'Pump Transport',
  'Crane Transport',
  'Construction Equipment',
  'Skid Transport',
  'Bulk Haulage Contracts',
  'Crate Transport'
];

export const mockPressArticles = [
  {
    logo: '7news',
    title: "'Pride of the Murray' begins long journey from Victoria to Queensland",
    link: '#'
  },
  {
    logo: 'bigrigs',
    title: "Pride of the Murray's epic journey - day one",
    link: '#'
  },
  {
    logo: 'bigrigs',
    title: 'Opening a world of opportunities',
    link: '#'
  }
];

export const mockClientLogos = [
  'Client 1',
  'Client 2',
  'Client 3',
  'Client 4',
  'Client 5',
  'Client 6',
  'Client 7',
  'Client 8',
  'Client 9',
  'Client 10',
  'Client 11',
  'Client 12',
  'Client 13',
  'Client 14'
];